import { UseQueryResult } from '@tanstack/react-query'
import {
  PointMileageSummaryResponse,
  getPointMileageSummary,
} from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import { useAtomValue } from 'jotai/index'

import { mockHost } from '@/apis'
import { storageMockEnabled } from '@/atoms'
import { useQueryWrapper } from '@/hooks/useQueryWrapper'
import { KEYS } from '@/react-query/keys'

interface Props {
  useErrorBoundary?: boolean
  enabled?: boolean
}

function useGetTmapPayPointsSummary(
  props: Props
): UseQueryResult<PointMileageSummaryResponse, AxiosError> {
  const storageMock = useAtomValue(storageMockEnabled)
  return useQueryWrapper<PointMileageSummaryResponse, AxiosError>(
    KEYS.USER_POINT(),
    async () => {
      if (storageMock) {
        const { data } = await mockHost.get<PointMileageSummaryResponse>(
          '/tmappay/point-api/v3/points/summary'
        )
        return data
      } else {
        const { data } = await getPointMileageSummary()
        return data
      }
    },
    {
      useErrorBoundary: props?.useErrorBoundary ?? true,
      enabled: props?.enabled ?? true,
    }
  )
}

export { useGetTmapPayPointsSummary }
